var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback } from 'react';
import Wiki from './Wiki';
import Map from './Map';
import Painting from './Painting';
import { usePrevious, placeNameForReverseGeo, setStyle, makeid, countryLookup, } from '../utils/helpers';
import './Painting.scss';
import RandomIcon from '../assets/svg/random.svg';
// testjpf make it so if you click on marker
// it takes you to that "page" in pagination for wiki result
export default React.memo(function (props) {
    var paintings = props.paintings, resultsId = props.resultsId, randomSearch = props.randomSearch;
    var prevResultsId = usePrevious(resultsId);
    var _a = useState(true), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState(0), page = _b[0], setPage = _b[1];
    var prevPage = usePrevious(page);
    var _c = useState(false), returnError = _c[0], setReturnError = _c[1];
    var _d = useState(), cityName = _d[0], setCityName = _d[1];
    var prevCityName = usePrevious(cityName);
    var _e = useState({}), mapCenter = _e[0], setMapCenter = _e[1];
    var _f = useState([]), geoResultCoords = _f[0], setGeoResultCoords = _f[1];
    var _g = useState([]), wikiCoords = _g[0], setWikiCoords = _g[1];
    var _h = useState(0), geoResultsI = _h[0], setGeoResultsI = _h[1];
    var getGeosNearPlaceName = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var city;
        return __generator(this, function (_a) {
            if (!cityName)
                return [2 /*return*/, null];
            city = countryLookup[cityName]
                ? countryLookup[cityName]
                : cityName;
            city = city
                .replace(/-.*, /, ' ')
                .replace('(', ' ')
                .replace('probably', '')
                .replace(',', ' ');
            fetch("https://geocode.maps.co/search?q=".concat(city.split('/')[0]), {
                method: 'GET',
            })
                .then(function (response) { return response.json(); })
                .then(function (responseData) {
                setGeoResultCoords(responseData);
            })
                .catch(function (error) {
                setReturnError(true);
                console.log(error);
            });
            return [2 /*return*/];
        });
    }); }, [cityName]);
    function loadPainting(p) {
        setIsLoading(true);
        setStyle(p.colors);
        setCityName(placeNameForReverseGeo(p));
    }
    useEffect(function () {
        if (page && page >= 0 && prevPage !== page && paintings[page]) {
            loadPainting(paintings[page]);
            // page through current painitngs
        }
        else if (page >= 0 &&
            prevResultsId !== resultsId &&
            paintings.length > 0) {
            // new paintings from search
            loadPainting(paintings[0]);
            setPage(0);
        }
    }, [page, paintings, prevPage, prevResultsId, resultsId]);
    useEffect(function () {
        if (cityName && prevCityName !== cityName) {
            // get coordinates around painting location
            getGeosNearPlaceName();
            // clean up conditional testjpf???
        }
        else if ((cityName &&
            prevCityName === cityName &&
            prevResultsId !== resultsId) ||
            (cityName && prevResultsId === resultsId && isLoading === true)) {
            setIsLoading(false);
        }
    }, [
        cityName,
        getGeosNearPlaceName,
        isLoading,
        prevCityName,
        prevResultsId,
        resultsId,
    ]);
    // Testjpf abstract error component
    return (_jsx("main", __assign({ className: "main" }, { children: paintings && paintings.length > 0 && isLoading === false ? (_jsxs(_Fragment, { children: [paintings[page] && geoResultCoords && (_jsx(Painting, { paintings: paintings, cityName: cityName, page: page, setPage: setPage })), _jsxs("div", __assign({ className: "map-wiki flx-ctr wrap" }, { children: [geoResultCoords && geoResultCoords.length > 0 && cityName && (_jsx(Wiki, { setWikiCoords: setWikiCoords, setMapCenter: setMapCenter, cityName: cityName, coords: geoResultCoords, geoResultsI: geoResultsI })), _jsx("div", __assign({ className: "map" }, { children: page > -1 &&
                                mapCenter &&
                                mapCenter.lat &&
                                ((wikiCoords && wikiCoords.length > 0) ||
                                    (geoResultCoords && geoResultCoords.length > 0)) && (_jsx(Map, { wikicoords: wikiCoords, wikiMapCenter: mapCenter, coords: geoResultCoords, setGeoResultsI: setGeoResultsI, paintingPage: page })) }))] }))] })) : (_jsxs("div", __assign({ className: "painting__frame flx-ctr" }, { children: [returnError && (_jsx("div", __assign({ className: "search-error" }, { children: "ERROR: something went wrong" }))), isLoading ? (_jsx("div", __assign({ className: "painting flx-ctr fadein" }, { children: _jsx("svg", __assign({ className: "loading", viewBox: "25 25 50 50" }, { children: _jsx("circle", { cx: "50", cy: "50", r: "20" }) })) }))) : (_jsxs("div", __assign({ className: "no_results" }, { children: [_jsx("p", { children: "These tags did not return any results" }), _jsxs("button", __assign({ type: "button", onClick: function () { return randomSearch(makeid(6)); } }, { children: ["random", _jsx("br", {}), _jsx("img", { src: RandomIcon, alt: "random search term icon" })] }))] })))] }))) })));
});
